import React from 'react'
import EkycDocumentFooter from 'e-submission/components/Card/EkycDocumentFooter'

const withHoc = (hoc) => {
  const WrappedComponent = (props) => {
    return <EkycDocumentFooter {...props} />
  }

  return hoc(WrappedComponent)
}

export default withHoc
